import { useAuthContext } from "src/auth/AuthContext";
import CommitmentsForm from "./CommitmentsForm";
import { useParams } from "react-router-dom";

const CommitmentsView = () => {
    const { user } = useAuthContext();
    const { id } = useParams();
    return <CommitmentsForm commitmentId={parseInt(id)} organizationId={user.data.organizationId} onSubmit={(_ps) => Promise.resolve()} viewOnly={true} header='Ansicht' />
}

export default CommitmentsView